import React from 'react';
import '../css/team/Team.css';
import SEO from './SEO';

const Team = () => {
  const teamMembers = [
    {
      id: 1,
      name: 'Sangam Gupta',
      role: 'Managing Director',
      qualification: 'CA (Chartered Accountant)',
      description: 'Leading the company with strategic vision and financial expertise. Bringing years of experience in investment management and business development.',
      icon: 'fas fa-user-tie',
      expertise: ['Financial Strategy', 'Investment Analysis', 'Business Development', 'Risk Management']
    },
    {
      id: 2,
      name: 'Madhulika Gupta',
      role: 'Director',
      qualification: '',
      description: 'Overseeing operations and ensuring seamless execution of investment strategies. Expert in portfolio management and client relations.',
      icon: 'fas fa-user-graduate',
      expertise: ['Operations Management', 'Portfolio Strategy', 'Client Relations', 'Market Analysis']
    },
    {
      id: 3,
      name: 'Aparajita Gupta',
      role: 'Promoter',
      qualification: '',
      description: 'Driving innovation and growth initiatives. Focused on identifying new opportunities and market expansion strategies.',
      icon: 'fas fa-lightbulb',
      expertise: ['Business Development', 'Market Research', 'Innovation Strategy', 'Growth Planning']
    },
    {
      id: 4,
      name: 'Awijit Gupta',
      role: 'Promoter',
      qualification: '',
      description: 'Spearheading technology integration and modern investment approaches. Bringing fresh perspectives to traditional investment methodologies.',
      icon: 'fas fa-chart-line',
      expertise: ['Technology Integration', 'Modern Investment', 'Process Optimization', 'Digital Strategy']
    }
  ];

  return (
    <>
      <SEO 
        title="Samapaw Team - Expert Financial Professionals"
        description="Meet Samapaw experienced team of financial professionals. Our dedicated Samapaw experts provide personalized wealth management and investment advisory services in Gurugram, Haryana. The Samapaw Sampatti team is committed to your financial success."
        keywords="Samapaw team, Samapaw financial team Gurugram, Samapaw wealth management experts, Samapaw investment advisors India, Samapaw financial professionals Haryana, Samapaw portfolio management team, Samapaw business finance experts, Sama paw team"
        section="team"
      />
      <section id="team" className="team">
      <div className="container">
        <div className="team-header text-center">
          <h2>Our Leadership Team</h2>
          <div className="section-divider"></div>
          <p className="section-subtitle">
            Meet the experienced professionals leading Samapaw Sampatti towards excellence
          </p>
        </div>

        <div className="team-grid">
          {teamMembers.map(member => (
            <div key={member.id} className="team-card">
              <div className="team-card-inner">
                <div className="team-card-front">
                  <div className="member-avatar">
                    <i className={member.icon}></i>
                  </div>
                  <div className="member-info">
                    <h3>{member.name}</h3>
                    {member.qualification && (
                      <span className="qualification">{member.qualification}</span>
                    )}
                    <span className="role">{member.role}</span>
                    <p className="member-description">{member.description}</p>
                  </div>
                  <div className="flip-indicator">
                    <i className="fas fa-info-circle"></i>
                    <span>View Expertise</span>
                  </div>
                </div>

                <div className="team-card-back">
                  <div className="back-header">
                    <h4>{member.name}</h4>
                    <span>{member.role}</span>
                  </div>
                  <div className="expertise-section">
                    <h5>Areas of Expertise</h5>
                    <ul className="expertise-list">
                      {member.expertise.map((skill, index) => (
                        <li key={index}>
                          <i className="fas fa-check-circle"></i>
                          {skill}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="team-values">
          <h3>Our Core Values</h3>
          <div className="values-grid">
            <div className="value-item">
              <div className="value-icon">
                <i className="fas fa-handshake"></i>
              </div>
              <h4>Integrity</h4>
              <p>Conducting business with the highest ethical standards</p>
            </div>
            <div className="value-item">
              <div className="value-icon">
                <i className="fas fa-bullseye"></i>
              </div>
              <h4>Excellence</h4>
              <p>Striving for superior results in every endeavor</p>
            </div>
            <div className="value-item">
              <div className="value-icon">
                <i className="fas fa-users"></i>
              </div>
              <h4>Collaboration</h4>
              <p>Working together to achieve shared success</p>
            </div>
            <div className="value-item">
              <div className="value-icon">
                <i className="fas fa-rocket"></i>
              </div>
              <h4>Innovation</h4>
              <p>Embracing new ideas and approaches</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default Team;